import { addressModel } from "./address..model";
import { clientDetailsModel } from "./clientDetails.model";

export const orderModel = {
  userID: null, // will be populated if userType is "Registered"
  orderDate: new Date(),
  totalAmount: 0.0,
  orderItems: [],
  shippingAddress: { ...addressModel },
  billingAddress: null,
  deliveryType: null,
  discountGroupon: "",
  client:{...clientDetailsModel}
};
